import { LogoPropsType } from './logoTypes';

export default function RevolutLogo({ monochrome = false, className }: LogoPropsType) {
  return (
    <svg
      viewBox="0 0 923.1 207.7"
      fill={monochrome ? 'currentColor' : '#FFFFFF'}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g>
        <path
          d="M599,75.6c-15.6-13.7-34.4-20.4-56.1-20.4c-21.4,0-40.2,6.7-55.8,20.4c-15.6,13.4-23.5,32-23.5,55.9
			c0,23.9,7.9,42.5,23.5,56.1c15.6,13.4,34.4,20.1,55.8,20.1c21.7,0,40.5-6.7,56.1-20.1c15.9-13.7,23.8-32.3,23.8-56.1
			S614.9,89,599,75.6z M513.6,162c-8.2-7.8-12.3-18-12.3-30.5c0-12.5,4.1-22.7,12.3-30.3c8.2-7.8,17.9-11.6,29.3-11.6
			c11.4,0,21.4,3.8,29.6,11.6c8.5,7.6,12.6,17.7,12.6,30.3c0,12.5-4.1,22.7-12.6,30.5c-8.2,7.6-18.2,11.3-29.6,11.3
			C531.5,173.4,521.8,169.6,513.6,162z M678.3,203.6V4h-37v199.6H678.3z M797.7,59.3V139c0,19.2-10.5,31.9-30.4,31.9
			c-20.3,0-30.5-12.7-30.5-31.9V59.3h-37.1v85.8c0,33.2,21.1,62.6,67.5,62.6h0.3c46.1,0,67.2-30,67.2-62.6V59.3L797.7,59.3z
			M424.3,59.3l-37,97.7l-37-97.7H311l59,144.3h34.7l59-144.3H424.3z M311.2,127.4c0-20.9-6.7-38.1-20-51.8
			C278,62,261,55.3,240.1,55.3c-21.4,0-39.6,7.3-54.6,21.5c-14.7,14.3-22,32.3-22,54.7c0,22.4,7.3,40.7,21.7,55
			c14.7,14.3,32.3,21.2,53.1,21.2c32,0,54.6-14,68.4-42.2l-27.6-15.7c-9.1,17.7-22.3,26.5-40.2,26.5c-22,0-37.6-14-39.9-36.1h112.1
			L311.2,127.4L311.2,127.4z M238.9,83.2c20.8,0,34.7,11.6,38.2,30.3H199C204.6,96.3,219.9,83.2,238.9,83.2z M163.5,203.6
			l-49.6-86.1c31.4-11.3,47-31.1,47-59.9C160.9,22.4,132.7,0,87.8,0H0v203.6h38.8V121h32.9l47.5,82.6H163.5z M87.8,33.7
			c22.9,0,34.4,9,34.4,26.8c0,17.7-11.5,26.8-34.4,26.8h-49V33.7H87.8z M897.5,207.7c-23.8,0-43.1-19.1-43.1-42.8V20.4h37v39h31.7
			v29.7h-31.7v73.5c0,6.9,5.7,12.5,12.7,12.5h19.1v32.6H897.5z"
        />
      </g>
    </svg>
  );
}
